import postRobot from '@mc-alberta/messenger'
import CONSTANTS from '@/constants'

export const fetchPostMessage = (params = new URLSearchParams()) => {
  if (params.get('initiator') !== CONSTANTS.DCF) {
    return
  }
  const security = {
    domain: process.env.MASTERCARD_SRC_HOST.replace(/\/$/, ''),
    window: window.opener
  }
  return postRobot
    .send(window.opener, 'AMS_READY', null, security)
    .then(({ data }) => data || {})
    .catch((err) => err)
}
